package com.vizio.redwolf.dms.model

import kotlinx.serialization.Serializable

@Serializable
data class VoiceLinkingConfig(
    val alexaEnabled: Boolean? = null,
    val alexaSynced: Boolean? = null,
    val googleAssistantEnabled: Boolean? = null,
    val googleAssistantSynced: Boolean? = null
)

data class RequestNonceRequestInfo(
    val deviceInstanceId: String,
    val friendlyName: String,
    val modelName: String,
    val serialNumber: String,
    val skipCreditCard: Boolean? = null,
    val launchSource: String? = null
)

data class LinkNonceRequestInfo(
    val authorizationCode: String,
    val pendingDevicePin: String,
    val state: String
)

data class FieldedStatusRequestInfo(
    val pin: String,
    val isLookupUserId: Boolean? = null
)